import { RootEntityName } from '@contember-cloud/studio-plugins';
import { formatEntityName, formatFieldName, formatPluginName } from '../../../common';
import { createSchemaStatementHandler } from '../../createSchemaStatementHandler';
export const removePluginStmtInstruction = `
#### Remove plugin
- Syntax: \`remove plugin <plugin_type> <entity_name>.<field_name>;\`
- Example: \`remove plugin richText Article.content;\``;
// todo: remove orphaned plugin entities
// todo: remove plugin from extensions
export const stmtRemovePlugin = (args) => {
    if (!args.fieldName) {
        return `remove plugin ${args.pluginName} ${args.entityName};`;
    }
    return `remove plugin ${args.pluginName} ${args.entityName}.${args.fieldName};`;
};
export const stmtForHumanRemovePlugin = (args) => {
    if (!args.fieldName) {
        return `Remove the plugin __${args.pluginName}__ from the table __${args.entityName}__`;
    }
    return `Remove the plugin __${args.pluginName}__ from the column __${args.fieldName}__ in the table __${args.entityName}__`;
};
export const removePluginHandler = createSchemaStatementHandler({
    type: 'remove plugin',
    parse: line => {
        const match = /^remove plugin (?<pluginName>[\w\-_.]+) (?<entityName>\w+)(\.(?<fieldName>\w+))?/.exec(line);
        return match?.groups
            ? {
                type: 'remove plugin',
                pluginName: formatPluginName(match.groups.pluginName),
                entityName: formatEntityName(match.groups.entityName),
                fieldName: match.groups.fieldName ? formatFieldName(match.groups.fieldName) : undefined,
            }
            : null;
    },
    getHumanStmt: stmtForHumanRemovePlugin,
    apply: (stmt, builder) => {
        builder.updateSchema(it => (stmt.fieldName ? it.removeField(stmt.entityName, stmt.fieldName) : it));
        builder.updateSchemaExtensions(it => {
            const existingFields = it.plugins[stmt.pluginName]?.connectedTo?.[stmt.entityName]?.fields || [];
            it.plugins[stmt.pluginName].connectedTo[stmt.entityName].fields = existingFields.filter(f => f !== stmt.fieldName);
            if (!Object.values(it.plugins[stmt.pluginName].connectedTo).some(it => !!it.fields?.length)) {
                const pluginSchema = it.plugins[stmt.pluginName].schema;
                builder.updateSchema(it => {
                    for (const pluginEntityName of Object.keys(pluginSchema?.model.entities ?? {})) {
                        // TODO: use processPlugin to remove plugin entities
                        if (pluginEntityName !== RootEntityName) {
                            it = it.removeEntity(pluginEntityName);
                        }
                    }
                    for (const pluginEnumName of Object.keys(pluginSchema?.model.enums ?? {})) {
                        it = it.removeEnum(pluginEnumName);
                    }
                    return it;
                });
                delete it.plugins[stmt.pluginName];
            }
            return it;
        });
    },
});
//# sourceMappingURL=RemovePluginStmt.js.map